export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Brand contact / config — easy to update from one place
export const CONTACT = {
  email: "info@jynova.be",
  // WhatsApp number in international format, no spaces or +. Easy to update.
  whatsappNumber: "32483232163",
  whatsappMessage:
    "Hallo JYNOVA, ik wil graag een richtprijs voor Privacy Smart Film.",
  company: {
    name: "JYNOVA",
    vat: "BE0662.926.803",
    address: "Jozef Voldersstraat 13, B-3970 Leopoldsburg",
    region: "België",
  },
  socials: {
    instagram: "https://www.instagram.com/jynova.be/",
    facebook: "https://www.facebook.com/profile.php?id=61589303066498",
    linkedin: "#",
  },
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_3787040a-07e9-4513-9f9f-6906e199c3e8/artifacts/pcqqlu1s_ChatGPT%20Image%203%20mei%202026%2C%2018_35_42.png",
  // Hero: modern interior with floor-to-ceiling glass (privacy film context)
  hero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
  // Smart film context visual (marketing artwork — already branded with JYNOVA + 4 contexts)
  smartFilmContext:
    "https://customer-assets.emergentagent.com/job_jynova-preview/artifacts/241dk64a_2eeffde1-e42c-4349-95e3-88c4ab3baa1a.jpg",
  // Modern home with smart film (B2C feel) used in before/after grid
  homeBeforeAfter:
    "https://customer-assets.emergentagent.com/job_jynova-preview/artifacts/vefz4v5q_fdf77544-73ec-4984-a4ab-24069e0cb7a2.jpg",
  privacy:
    "https://customer-assets.emergentagent.com/job_jynova-preview/artifacts/twf03kvi_smart-glass-film%20%284%29.jpg",
  led: "https://customer-assets.emergentagent.com/job_3787040a-07e9-4513-9f9f-6906e199c3e8/artifacts/ldp37148_ChatGPT%20Image%203%20mei%202026%2C%2018_35_18.png",
  panels:
    "https://customer-assets.emergentagent.com/job_jynova-preview/artifacts/dug25h6k_image_2026-05-05_022813417.png",
};
